import { CityLocation } from "@app/data/location/schema";

export const ALL_RUSSIA: CityLocation = {
  region: "Россия",
  city: "Вся Россия",
  latitude: "0",
  longitude: "0"
}

export const getLargestCitiesOfRussia = (firstCity: CityLocation): CityLocation[] => {
  const cities: CityLocation[] = [
    { region: "Москва", city: "Москва", latitude: "55.7558", longitude: "37.6173" },
    { region: "Санкт-Петербург", city: "Санкт-Петербург", latitude: "59.9343", longitude: "30.3351" },
    { region: "Новосибирская область", city: "Новосибирск", latitude: "55.0084", longitude: "82.9357" },
    { region: "Свердловская область", city: "Екатеринбург", latitude: "56.8389", longitude: "60.6057" },
    { region: "Нижегородская область", city: "Нижний Новгород", latitude: "56.2965", longitude: "43.9361" },
    { region: "Татарстан", city: "Казань", latitude: "55.7963", longitude: "49.1088" },
    { region: "Челябинская область", city: "Челябинск", latitude: "55.1644", longitude: "61.4368" },
    { region: "Омская область", city: "Омск", latitude: "54.9885", longitude: "73.3242" },
    { region: "Самарская область", city: "Самара", latitude: "53.1959", longitude: "50.1002" },
    { region: "Ростовская область", city: "Ростов-на-Дону", latitude: "47.2357", longitude: "39.7015" },
    { region: "Красноярский край", city: "Красноярск", latitude: "56.0153", longitude: "92.8932" },
    { region: "Краснодарский край", city: "Краснодар", latitude: "45.0448", longitude: "38.9760" },
    { region: "Калининградская область", city: "Калининград", latitude: "54.7104", longitude: "20.4522" },
    { region: "Тюменская область", city: "Тюмень", latitude: "57.1522", longitude: "68.0022" },
    { region: "Иркутская область", city: "Иркутск", latitude: "52.2978", longitude: "104.2964" },
  ];

  // Удаляем город из списка, если он уже присутствует
  const filteredCities = cities.filter(city => city.city !== firstCity.city && city.city !== "Вся Россия");

  // Вся Россия всегда первой, потом текущий город (если не «Вся Россия»), потом остальные
  const isAllRussia = firstCity.city === "Вся Россия" || !firstCity.city
  return isAllRussia ? [ALL_RUSSIA, ...filteredCities] : [ALL_RUSSIA, firstCity, ...filteredCities];
};